import { render, staticRenderFns } from "./OrderMenu.vue?vue&type=template&id=2374abb0&scoped=true"
import script from "./OrderMenu.vue?vue&type=script&lang=js"
export * from "./OrderMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2374abb0",
  null
  
)

export default component.exports